import React, { useContext, useMemo } from 'react';
import { useUserInfo } from '../UserInfo';

type EmployeeIdContextValue = {
  employeeId: string;
  isManagerView: boolean;
};

const EmployeeIdContext = React.createContext<EmployeeIdContextValue | null>(
  null,
);

type EmployeeIdProviderProps = {
  employeeId?: string;
  children: React.ReactNode;
};

export const EmployeeIdProvider: React.FC<EmployeeIdProviderProps> = ({
  employeeId,
  children,
}) => {
  const { id: meId } = useUserInfo();

  const value = useMemo(
    () => ({
      employeeId: employeeId ?? meId,
      isManagerView: employeeId !== undefined && employeeId !== meId,
    }),
    [employeeId, meId],
  );

  return (
    <EmployeeIdContext.Provider value={value}>
      {children}
    </EmployeeIdContext.Provider>
  );
};

export const useEmployeeIdContext = (): EmployeeIdContextValue => {
  const context = useContext(EmployeeIdContext);
  const { id: meId } = useUserInfo();

  const fallbackValue = useMemo(
    () => ({
      employeeId: meId,
      isManagerView: false,
    }),
    [meId],
  );

  return context ?? fallbackValue;
};
